<template>
  <div class="question-box-warry">
    <el-card :body-style="{ padding: '0px' }" shadow="hover">
      <div class="stem" v-html="calOption(question.stem)"></div>
      <ul class="options" v-if="question.options">
        <li v-for="(option, key, index) in question.options" v-html="key + '：' + calOption(option)"></li>
      </ul>
      <div v-for="(childItem, index) in question.children" class="children">
        <div v-if="childItem.stem==''" style="margin: 6px 0 -5px 0px" class="question-font-lineheight-style">【小题{{index + 1}}】</div>
        <span class="question-number question-font-lineheight-style"  v-else>【小题{{index + 1}}】</span>
        <div class="indent child question-font-lineheight-style" v-html="calOption(childItem.stem)"></div>
        <ul class="options">
          <li v-for="(option, key, index) in childItem.options" v-html="key + '：' + calOption(option)"></li>
        </ul>
      </div>
      <div class="answer">
        <el-row>
          <el-col :span="2" class="text-align-left color-red">
            【答 案】
          </el-col>
          <el-col :span="22">
            <div v-html="calOption(question.answer)"></div>
            <template v-for="(childItem, index) in question.children">
              <div class="ans_child">
                <span class="question-number question-font-lineheight-style">【小题{{index + 1}}】</span>
                <div class="indent child question-font-lineheight-style" v-html="calOption(childItem.answer)"></div>
              </div>
            </template>
          </el-col>
        </el-row>
      </div>
      <div class="analysis">
        <el-col :span="2" class="text-align-left color-green">
          【解 析】
        </el-col>
        <el-col :span="22">
          <div v-html="calOption(question.analysis)"></div>
          <template v-for="(childItem, index) in question.children">
            <div class="ans_child">
              <span class="question-number question-font-lineheight-style">【小题{{index + 1}}】</span>
              <div class="indent child question-font-lineheight-style" v-html="calOption(childItem.analysis)"></div>
            </div>
          </template>
        </el-col>
      </div>
    </el-card>
  </div>
</template>
<script>
export default {
  name: 'question-box',
  data () {
    return {

    }
  },
  props: {
    question: {
      type: Object,
      required: true
    }
  },

  computed: {
  },
  mounted () {

  },
  methods: {
    calOption (_option) {
      let newoptions = ''
      if (_option) {
        let newimgsrc = 'src="http://jty-xbzyk.obs.cn-north-4.myhuaweicloud.com/'
        let reg = new RegExp('src="/', 'g')
        newoptions = _option.replace(reg, newimgsrc)
      }
      return newoptions
    }
  }
}
</script>

<style scoped>

</style>
<style type="text/css">

  .question-box-warry{
    font-size: 14px!important;
    font-family: MicrosoftYaHei;
    margin-bottom: 10px;
  }

  .question-box-warry .stem{
    color: #474747;
    line-height: 30px!important;
    padding: 10px 20px;
    position: relative;
  }

  .question-box-warry .children{
    position: relative;
  }

  .question-box-warry .options{
    margin: 10px 20px;
  }

  .question-box-warry .options li{
    display: inline-block;
    padding-right: 20px;
    min-width: 180px;
    margin: 5px 0;
  }

  .question-box-warry .children{
    margin-left: 20px;
  }

  .answer{
    font-size: 14px;
    font-weight: 400;
    color: #666;
    margin: 0;
    line-height: 30px;
    padding: 0 17px;
    border-top: 1px dashed #22b993;
  }

  .color-red{
    color: #ff5643;
  }

  .color-green{
    color: #2ac287;
  }

  .text-align-left{
    text-align: left;
  }

  .analysis{
    overflow: hidden;
    font-size: 14px;
    font-weight: 400;
    color: #666;
    margin: 0;
    line-height: 30px;
    padding: 0 17px;
    border-top: 1px dashed rgba(34,185,147,.4);
  }

  .ans_child{
    position: relative;
    min-height: 20px;
  }

  .question-number{
    position: absolute;
    top: 0;
  }

  .question-font-lineheight-style {
    color: #474747;
    line-height: 30px!important;
  }

  .indent.child {
    text-indent: 65px;
  }

</style>



// WEBPACK FOOTER //
// src/components/question/question-box.vue